import { updateTbEnrollmentIsOnline, resetPlayerScore, historicalGameStatistics, competitionBySeason, competitionStatisticsBySeason, historicalCompetitionStatistics } from '@/http/api'
export default {
  data () {
    return {
      currentMenuTag: '',
      racingToolTitle: '',
      scoreEntryList: [
        {
          rightTitle: '练习题成绩',
          rightDesc: '查看练习题成绩及作答详情',
          icon: 'icon-huihuajinglingicon-351',
          menuTag: '6',
          authorityFlag: this.$chnEngStatusCode.exercise_scores,
          path: '/examination_Management/eas'
        }
      ],
      racingToolList: [
        {
          leftImg: require('@/assets/img/icon-rili.png'),
          rightTitle: '重置选手成绩',
          rightDesc: '重置选手线上初选/区域决选成绩',
          icon: 'icon-bg-reset',
          dialogTitle: '重置选手成绩',
          menuTag: '3',
          authorityFlag: this.$chnEngStatusCode.reset_player_score,
          showPop: true
        },
        {
          leftImg: require('@/assets/img/icon-diannao.png'),
          rightTitle: '参赛方式管理',
          rightDesc: '修改用户参赛方式',
          dialogTitle: '修改参赛方式',
          icon: 'icon-qiehuanmoshi',
          menuTag: '5',
          authorityFlag: this.$chnEngStatusCode.change_player_gametype,
          showPop: true
        }
      ],
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      gameTypeChangePoster: false,
      editGameTypeForm: {
        phone: '',
        season: this.$chnEngStatusCode.defaultSeason,
        remark: '',
        isOnline: '',
        raceSchedule: ''
      },
      editGameTypeFormRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        season: [{ required: true, message: '请选择赛季信息', trigger: 'change' }],
        raceSchedule: [{ required: true, message: '请选择比赛类型', trigger: 'change' }],
        isOnline: [{ required: true, message: '请选择成绩类型', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注信息', trigger: 'blur' }]
      },
      scoreFlagList: [
        {
          dictCode: 1,
          dictLabel: '城市初选',
          dictValue: 1,
          variable: true
        },
        {
          dictCode: 2,
          dictLabel: '区域决选',
          dictValue: 2,
          variable: false
        }
      ],
      scoreTypeList: [
        {
          dictCode: 1,
          dictLabel: '线上参赛',
          dictValue: 1
        },
        {
          dictCode: 0,
          dictLabel: '线下参赛',
          dictValue: 0
        }
      ],
      raceScheduleList: [
        {
          scheduleName: '城市初选',
          authorityFlag: this.$chnEngStatusCode.SCORE_INDIVIDUAL_PRELIMINARY
        }, {
          scheduleName: '区域决选',
          authorityFlag: this.$chnEngStatusCode.SCORE_INDIVIDUAL_FINAL
        }, {
        //   scheduleName: '区域决选',
        //   authorityFlag: this.$chnEngStatusCode.SCORE_CITY_REGIONAL_COMPETITION
        // }, {
          scheduleName: '全球总决选',
          authorityFlag: this.$chnEngStatusCode.SCORE_NATIONAL_FINALS
        }
      ],
      scheduleCardList: [
        {
          scheduleName: '初选',
          scheduleId: '1',
          promotionNum: 0,
          signUpNum: 0,
          historyPromotionNum: 0,
          historySignUpNum: 0,
          percent: 0,
          historyPercent: 0,
          backGround: '#57a3f7',
          flag: this.$chnEngStatusCode.INDIVIDUAL_PRELIMINARY
        }, {
          scheduleName: '复选',
          scheduleId: '2',
          promotionNum: 0,
          signUpNum: 0,
          historyPromotionNum: 0,
          historySignUpNum: 0,
          percent: 0,
          historyPercent: 0,
          backGround: '#febf3d',
          flag: this.$chnEngStatusCode.INDIVIDUAL_FINAL
        }, {
          scheduleName: '城市总决选',
          scheduleId: '3',
          promotionNum: 0,
          signUpNum: 0,
          historyPromotionNum: 0,
          historySignUpNum: 0,
          percent: 0,
          historyPercent: 0,
          backGround: '#52c1f5',
          flag: this.$chnEngStatusCode.CITY_REGIONAL_COMPETITION
        }, {
          scheduleName: '国赛有组别',
          scheduleId: '4',
          promotionNum: 0,
          signUpNum: 0,
          historyPromotionNum: 0,
          historySignUpNum: 0,
          percent: 0,
          historyPercent: 0,
          backGround: '#fb6260',
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }, {
          scheduleName: '国赛无组别',
          scheduleId: '4',
          promotionNum: 0,
          signUpNum: 0,
          historyPromotionNum: 0,
          historySignUpNum: 0,
          percent: 0,
          historyPercent: 0,
          backGround: '#8167f5',
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }
      ],
      indivScoreStatisticsList: [
        {
          scheduleName: '城市初选参赛人数',
          icon: 'icon-saishi',
          scheduleId: '1',
          promotionNum: 0,
          historyNum: 0,
          growth: '+45%'
        },
        {
          scheduleName: '城市初选晋级人数',
          icon: 'icon-tisheng',
          scheduleId: '2',
          promotionNum: 0,
          historyNum: 0,
          growth: '+45%'
        },
        {
          scheduleName: '区域决选参赛人数',
          icon: 'icon-saishi',
          scheduleId: '1',
          promotionNum: 0,
          historyNum: 0,
          growth: '+45%'
        },
        {
          scheduleName: '区域决选晋级人数',
          icon: 'icon-tisheng',
          scheduleId: '1',
          promotionNum: 0,
          historyNum: 0,
          growth: '+45%'
        }
      ]
    }
  },
  created () {
    // this.getData()
    // this.getRaceScheduleList()
    this.getRaceSchedules()
  },
  methods: {
    getRaceSchedules () {
      this.$http.get('/homePage/scheduleStatisticsBySeason', { params: { activityType: this.$chnEngStatusCode.activityType, season: this.$chnEngStatusCode.defaultSeason } }).then(res => {
        if (res.code === 200) {
          res.data.forEach((item, i) => {
            item.authorityFlag = `SCORE_${item.scheduleFlag}`
            if (i === 0) { // 初选
              item.path = '/examination_Management/individual_examination_management/schedule_competitions/schedule_individual_competition'
            } else if (i === 1) { // 复选
              item.path = '/examination_Management/individual_examination_management/schedule_competitions/schedule_rematch_competition'
            // } else if (i === 2) { // 区域
            //   item.path = ''
            } else if (i === 2) { // 总决选
              item.path = '/examination_Management/final_answer'
            }
          })
          this.raceScheduleList = res.data
        }
      })
    },
    // getRaceScheduleList () {
    //   this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(data => {
    //     const params = { activityType: this.$chnEngStatusCode.activityType }
    //     competitionStatisticsBySeason(params).then(res => {
    //       if (res.code === 200) {
    //         // 城市初选
    //         data[0].signUpNum = res.data.theNumberOfParticipantsInThePreliminaryRound
    //         data[0].promotionNum = res.data.theNumberOfParticipantsInThePreliminaryRoundPromotion
    //         // 区域决选
    //         data[1].signUpNum = res.data.numberOfParticipantsInTheRematch
    //         data[1].promotionNum = res.data.numberOfParticipantsInTheRematchPromotion
    //         // 城市总
    //         data[2].signUpNum = res.data.totalCityRunoff
    //         data[2].promotionNum = res.data.totalCityRunoffPromotion
    //         // 总决赛 有组别
    //         data[3].signUpNum = res.data.thereAreDivisionsInTheNationalCompetition
    //         data[3].promotionNum = res.data.thereAreDivisionsInTheNationalCompetitionPromotion
    //         // 总决赛 无组别
    //         // this.scheduleCardList[4].signUpNum = res.data.thereAreNoDivisionsInTheNationalCompetition
    //         // this.scheduleCardList[4].promotionNum = res.data.thereAreNoDivisionsInTheNationalCompetitionPromotion
    //         console.log(this.raceScheduleList)
    //         this.raceScheduleList = data
    //       }
    //     })
    //   })
    // },
    // // 考务工具点击
    // racingToolClicked (item) {
    //   this.currentMenuTag = item.menuTag
    //   this.racingToolTitle = item.dialogTitle
    //   switch (item.menuTag) {
    //     case '2': // 表单答题管理
    //       this.$router.push({ path: '/examination_Management/fas' })
    //       break
    //     case '6': // 练习题答题管理
    //       this.$router.push({ path: '/examination_Management/eas' })
    //       break
    //     case '3': // 重置选手成绩
    //       this.gameTypeChangePoster = true
    //       break
    //     case '5': // 参赛方式管理
    //       this.gameTypeChangePoster = true
    //       break
    //     default:
    //       break
    //   }
    // },
    showPop (item) {
      this.currentMenuTag = item.menuTag
      this.racingToolTitle = item.dialogTitle
      switch (item.menuTag) {
        case '3': // 重置选手成绩
          this.gameTypeChangePoster = true
          break
        case '5': // 参赛方式管理
          this.gameTypeChangePoster = true
          break
        default:
          break
      }
    },
    // 修改参赛形式
    editGameTypeScore () {
      this.$refs.editGameTypeFormRef.validate(async valid => {
        if (!valid) return
        if (this.currentMenuTag === '3') {
          const data = {
            activityType: this.$chnEngStatusCode.activityType,
            phone: this.editGameTypeForm.phone,
            raceSchedule: this.editGameTypeForm.raceSchedule,
            reason: this.editGameTypeForm.remark,
            season: this.editGameTypeForm.season
          }
          resetPlayerScore(data).then((res) => {
            this.gameTypeChangePoster = false
            return this.$message.success('修改成功')
          }).catch((err) => {
            console.log('err', err)
          })
        } else if (this.currentMenuTag === '5') {
          updateTbEnrollmentIsOnline(this.editGameTypeForm).then((res) => {
            this.gameTypeChangePoster = false
            return this.$message.success('修改成功')
          }).catch((err) => {
            console.log('err', err)
          })
        }
      })
    },
    // 修改参赛方式关闭
    editGameTypeDialogClose () {
      this.$refs.editGameTypeFormRef.resetFields()
    },
    getData () {
      const params = { activityType: this.$chnEngStatusCode.activityType }
      competitionStatisticsBySeason(params).then(res => {
        this.scheduleCardList[0].signUpNum = res.data.theNumberOfParticipantsInThePreliminaryRound || 0
        this.scheduleCardList[0].promotionNum = res.data.theNumberOfParticipantsInThePreliminaryRoundPromotion || 0
        this.scheduleCardList[1].signUpNum = res.data.numberOfParticipantsInTheRematch || 0
        this.scheduleCardList[1].promotionNum = res.data.numberOfParticipantsInTheRematchPromotion || 0
        this.scheduleCardList[2].signUpNum = res.data.totalCityRunoff || 0
        this.scheduleCardList[2].promotionNum = res.data.totalCityRunoffPromotion || 0
        this.scheduleCardList[3].signUpNum = res.data.thereAreDivisionsInTheNationalCompetition || 0
        this.scheduleCardList[3].promotionNum = res.data.thereAreDivisionsInTheNationalCompetitionPromotion || 0
        this.scheduleCardList[4].signUpNum = res.data.thereAreNoDivisionsInTheNationalCompetition || 0
        this.scheduleCardList[4].promotionNum = res.data.thereAreNoDivisionsInTheNationalCompetitionPromotion || 0

        this.scheduleCardList.forEach(item => {
          item.percent = item.signUpNum ? (item.promotionNum / item.signUpNum) * 100 : 0
        })
      })
      historicalCompetitionStatistics(params).then(res => {
        this.scheduleCardList[0].historySignUpNum = res.data.firstCompetitionNum || 0
        this.scheduleCardList[0].historyPromotionNum = res.data.firstCompetitionPromotionNum || 0
        this.scheduleCardList[1].historySignUpNum = res.data.secondCompetitionNum || 0
        this.scheduleCardList[1].historyPromotionNum = res.data.secondCompetitionPromotionNum || 0
        this.scheduleCardList[2].historySignUpNum = res.data.thirdCompetitionNum || 0
        this.scheduleCardList[2].historyPromotionNum = res.data.thirdCompetitionPromotionNum || 0
        this.scheduleCardList[3].historySignUpNum = res.data.fourthCompetitionNum || 0
        this.scheduleCardList[3].historyPromotionNum = res.data.fourthCompetitionPromotionNum || 0
        this.scheduleCardList[4].historySignUpNum = res.data.fifthCompetitionNum || 0
        this.scheduleCardList[4].historyPromotionNum = res.data.fifthCompetitionPromotionNum || 0

        this.scheduleCardList.forEach(item => {
          item.historyPercent = item.signUpNum ? (item.promotionNum / item.signUpNum) * 100 : 0
        })
      })
      competitionBySeason(params).then(res => {
        this.indivScoreStatisticsList[0].promotionNum = res.data.participantsPreliminaryRoundNum || 0
        this.indivScoreStatisticsList[1].promotionNum = res.data.participantsPreliminaryRoundNumPromotion || 0
        this.indivScoreStatisticsList[2].promotionNum = res.data.participantsInTheRematchNum || 0
        this.indivScoreStatisticsList[3].promotionNum = res.data.participantsInTheRematchNumPromotion || 0
      })
      historicalGameStatistics(params).then(res => {
        this.indivScoreStatisticsList[0].historyNum = res.data.firstCompetitionNum || 0
        this.indivScoreStatisticsList[1].historyNum = res.data.firstCompetitionPromotionNum || 0
        this.indivScoreStatisticsList[2].historyNum = res.data.secondCompetitionNum || 0
        this.indivScoreStatisticsList[3].historyNum = res.data.secondCompetitionPromotionNum || 0
      })
    }
  }
}
